import React, { useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useEffectOnce from '../hooks/useEffectOnce';
import { Message } from 'primereact/message';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../reducers';
import { AddData, fetchData } from '../reduxactions/organizationactions/OrgAddNeedsActions';
import { Card } from 'primereact/card';
import { Panel } from 'primereact/panel';
import { Dropdown, DropdownChangeEvent } from 'primereact/dropdown';
import { InputTextarea } from 'primereact/inputtextarea';
import { Toast } from 'primereact/toast';
// import './../layout/organisationlayout/OrganisationLayout.css';
// import '../layout/organisationlayout/OrganisationLayout'
const OrgAddNeeds = () => {

  interface NeedData {
    Id: string; // Change the type accordingly
    needtype: string; // Change the type accordingly
  }
  const [needsadd, setneedsadd] = useState(false);
  const [needIds, setNeedIds] = useState('');
  const [needtype, setNeedType] = useState<string>('');

  const [datas, setData] = useState<NeedData[]>([]);
  const [selectedNeed, setSelectedNeed] = useState<NeedData | null>(null);
  const [needId, setNeedId] = useState('');
  const [title, setTitle] = useState('');
  const [budget_amount, setAmount] = useState('');
  const [description, setDescription] = useState('');
  const [needstype, setNeedstype] = useState('needs'); // Assuming 'Needs' is the initial value
  const navigate = useNavigate();


  const uid = window.sessionStorage.getItem('uid');
  const [globalFilter, setGlobalFilter] = useState('')

  const dispatch = useDispatch();
  const fetchDataAsync = async () => {
    try {
      await dispatch(fetchData() as any);
    } catch (error) {
      console.error('Error fetching data', error)
    }
  }
  const data = useSelector((state: RootState) => state.orgaddneed.data);
  const adddata = useSelector((state: RootState) => state.orgaddneed.adddata);
  const toast = useRef(adddata);
  useEffectOnce(() => {
    fetchDataAsync();
  }, [dispatch]);
  //To dispatch add data 
  const AddNeeds = async () => {
    try {
      await dispatch(AddData(uid, selectedNeed?.Id, title, budget_amount, description) as any);
      const url = `/orgneeds`;
      navigate(url);
    } catch (error) {
      console.error('Error applying :', error);
    } toast.current.show({ severity: 'success', summary: 'Success', detail: adddata, life: 3000 })
    fetchDataAsync();
  }
  //for help
  const [openHelp, setHelp] = useState(false);
  const url1 = window.sessionStorage.getItem("apiRoot");
  const IUrl = `${url1}/help/org-addneeds.php`;
  const helpImg = `${url1}/help/help3.png`;
  const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
    event.preventDefault();
    const newWindowReference = window.open(
      targetUrl,
      'newwindow',
      'width=1000,height=1000,noopener,noreferrer'
    );

    if (newWindowReference) {
      newWindowReference.opener = null;
    }
  };
  return (
    <div className="admin-layout-container">
      <div className="row">
        <div className="main-content">
          <div className="content-wrapper">
            <section className="app-page-header">
              <div>
                <h1 className="app-page-title">Add Needs</h1>
              </div>
              <a title="help" onClick={(e) => openWindow(e, IUrl)} className="app-help-link">
                Help for this Page
                <i className="pi pi-question-circle"></i>
              </a>
            </section>
            <Panel>
              <div className="container-fluid">
                {/* <Card title="" className='border-blue-300 surface-overlay border-3 border-round font-bold m-2' > */}
                <Panel header="Add Needs">
                <div className="grid">

                  <div className="col-12 md:col-6">

                    <Panel header="Add Needs" className="shadow-1">

                      <div className="p-fluid">

                        {/* Add Needs */}
                        <div className="field grid mb-4">
                          <label className="block text-800 font-semibold mb-2">
                            Add Needs
                          </label>

                          <Dropdown
                            value={selectedNeed}
                            options={data}
                            optionLabel="needtype"
                            placeholder="Select Need Type"
                            data-testid="needtype-select"
                            className="w-full"
                            style={{ textAlign: "left" }}
                            onChange={(e: DropdownChangeEvent) => setSelectedNeed(e.value)}
                          />
                        </div>

                        {/* Need Title */}
                        <div className="field grid mb-4">
                          <label className="block text-800 font-semibold mb-2">
                            Need Title
                          </label>

                          <InputText
                            id="title"
                            placeholder="Need Title"
                            data-testid="title-input"
                            className="w-full"
                            onChange={(e) => setTitle(e.target.value)}
                          />
                        </div>

                        {/* Budget Amount */}
                        <div className="field grid mb-4">
                          <label className="block text-800 font-semibold mb-2">
                            Budget Amount
                          </label>

                          <InputText
                            id="amount"
                            placeholder="Enter Budget Amount"
                            data-testid="amount-input"
                            className="w-full"
                            onChange={(e) => setAmount(e.target.value)}
                          />
                        </div>

                        {/* Description */}
                        <div className="field grid mb-4">
                          <label className="block text-800 font-semibold mb-2">
                            Description
                          </label>

                          <InputTextarea
                            rows={4}
                            placeholder="Enter Description"
                            data-testid="desc-textarea"
                            className="w-full"
                            onChange={(e) => setDescription(e.target.value)}
                          />
                        </div>

                        {/* Button */}
                        <div className="flex justify-content-end mt-3">
                          <Button
                            label="Add Need"
                            icon="pi pi-plus"
                            severity="info"
                            data-testid="addneed-btn"
                            onClick={() => AddNeeds()}
                          />
                        </div>

                      </div>

                    </Panel>

                  </div>

                </div>
                </Panel>
                {/* </Card> */}
                <Toast ref={toast} >
                  <Message severity="success" content={adddata}></Message>
                </Toast>
              </div >
            </Panel >
          </div>
        </div>
      </div>
    </div>
  )
}

export default OrgAddNeeds
